import { render, staticRenderFns } from "./WDesktop.vue?vue&type=template&id=2a8ba179&scoped=true&"
import script from "./WDesktop.vue?vue&type=script&lang=js&"
export * from "./WDesktop.vue?vue&type=script&lang=js&"
import style0 from "./WDesktop.vue?vue&type=style&index=0&id=2a8ba179&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8ba179",
  null
  
)

/* custom blocks */
import block0 from "./WDesktop.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAvatar,VBadge,VBtn,VCard,VIcon,VImg,VLayout,VProgressCircular})
